import { InlineCalendar } from "PFComponents/calendar/inline_calendar";

import { ComponentPropTypes } from "../component_prop_types";

const InlineCalendarWrapper = ({
  property: { type },
  value,
  label,
  onChange,
  qaId,
  title,
  formattedTitle,
  style,
  error,
  required,
  disabled,
  variant,
  className,
  portalRef,
  tabIndex,
  inputRef
}) => (
  <InlineCalendar
    inputClassName={className}
    selectedDate={value}
    label={label}
    title={formattedTitle || title}
    qaId={qaId}
    error={error}
    required={required}
    showTime={type === "date-time"}
    shouldCloseOnSelection={type !== "date-time"}
    handleChange={onChange}
    disabled={disabled}
    variant={variant}
    portalRef={portalRef}
    letClear
    tabIndex={tabIndex}
    style={style}
    inputRef={inputRef}
  />
);

InlineCalendarWrapper.propTypes = ComponentPropTypes;

export default InlineCalendarWrapper;
